'use es6';

import { memo } from 'react';
import memoize from 'transmute/memoize';
import { DEFAULT_DEBUG } from '../../constants/debug';
import { SLICED } from '../../constants/visualizationTypes';
import Highchart from '../../highcharts/Highchart';
import { buildChartOptions } from './options/chartOptions';
import { mapVizToChart } from './slicedMapper';
import { SlicedVisualization } from './slicedRecords';
import { jsx as _jsx } from "react/jsx-runtime";
export const getHighchartsOptions = memoize((slicedVizualization, debug) => {
  const chart = mapVizToChart(slicedVizualization, debug);
  return buildChartOptions(chart);
});
export const type = SLICED;
export const record = SlicedVisualization;
const SlicedViz = ({
  visualization,
  debug = DEFAULT_DEBUG,
  onReportVisualize
}) => {
  const chartOptions = getHighchartsOptions(visualization, debug);
  debug.set('Highcharts', chartOptions);
  return /*#__PURE__*/_jsx(Highchart, {
    chartOptions: chartOptions,
    onReportVisualize: onReportVisualize
  });
};
export const Render = /*#__PURE__*/memo(SlicedViz);